import React from 'react';
import { MapPin, Send, Clock } from 'lucide-react';
import { fotos } from '@/constants/data';

const MapInfoSection = () => (
  <section className="bg-white" data-testid="map-info-section">
    <div className="w-full h-[350px] sm:h-[400px]">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d997.3!2d-60.0217!3d-3.1190!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x926c057b4bbfffff%3A0x0!2sR.%20Santa%20Quit%C3%A9ria%2C%20261%20-%20Pres.%20Vargas%2C%20Manaus%20-%20AM%2C%2069025-080!5e0!3m2!1spt-BR!2sbr!4v1"
        title="Localização Grupo Tomaselli"
        className="w-full h-full border-0"
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
    </div>

    <div className="relative">
      <div className="absolute inset-0 bg-[#0A2463]">
        <img src={fotos.conescap} alt="" className="w-full h-full object-cover opacity-20" />
        <div className="absolute inset-0 bg-[#0A2463]/80" />
      </div>
      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 text-center text-white">
          <div className="flex flex-col items-center">
            <MapPin size={32} className="text-white/60 mb-4" />
            <h3 className="font-heading text-xl sm:text-2xl mb-2">Endereço</h3>
            <p className="text-white/70 text-sm font-body leading-relaxed">
              Rua Santa Quitéria, 261 -<br />Presidente Vargas<br />Manaus - AM - 69025-080
            </p>
          </div>
          <div className="flex flex-col items-center">
            <Send size={32} className="text-white/60 mb-4" />
            <h3 className="font-heading text-xl sm:text-2xl mb-2">Entre em Contato</h3>
            <p className="text-white/70 text-sm font-body leading-relaxed">
              adm@grupotomaselli.com<br />+55 92 9 8802-0092
            </p>
          </div>
          <div className="flex flex-col items-center">
            <Clock size={32} className="text-white/60 mb-4" />
            <h3 className="font-heading text-xl sm:text-2xl mb-2">Escritório</h3>
            <p className="text-white/70 text-sm font-body leading-relaxed">
              Das 09h00 às 18h00<br />de segunda a sexta.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default MapInfoSection;
